export default "__VITE_ASSET__5ee9ab43__"